<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <form id="FormEntrada" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                        <label for="OrdenCompra">Orden de Compra</label>
                                        <div class="input-group">
                                            <input disabled v-model="OrdenCompraSeleccionada.Folio" id="OrdenCompra" type="text" class="form-control" placeholder="Ingresar Orden de Compra">
                                            <button @click="AbrirModalOrdenCompra" class="btn btn-outline-primary boder-extend" type="button"><i class="fas fa-search"></i></button>
                                        </div>
                                        <CValidation v-if="this.errorvalidacion.IdOrdenCompra" :Mensaje="'*'+errorvalidacion.IdOrdenCompra[0]"/>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                        <label for="Proveedor">Proveedor</label>
                                        <input disabled v-model="OrdenCompraSeleccionada.Proveedor" id="OrdenCompra" type="text" class="form-control" placeholder="Ingresar Proveedor">
                                        <CValidation v-if="this.errorvalidacion.Proveedor" :Mensaje="'*'+errorvalidacion.Proveedor[0]"/>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                        <label for="NLote">N° de Lote</label>
                                        <input v-model="objMovimiento.NLote" id="NLote" type="text" class="form-control" placeholder="Ingresar N° de Lote">
                                        <CValidation v-if="this.errorvalidacion.NLote" :Mensaje="'*'+errorvalidacion.NLote[0]"/>
                                    </div>
                                </div>
                                
                                <div class="form-group row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div class="table-responsive">
                                            <table class="table align-items-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Cantidad</th>
                                                        <th>Cantidad Entrante</th>
                                                        <th>Material</th>
                                                        <th>Unidad</th>
                                                        <th>Sub Unidad</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item,index) in Materiales" :key="index">
                                                        <td>{{ item.Cantidad }}</td>
                                                        <td>
                                                            <input type="text" class="form-control" v-model="item.CantidadEntrante" @input="$onlyNums($event,item,'CantidadEntrande')">
                                                        </td>
                                                        <td>{{ item.Material }}</td>
                                                        <td>{{ item.Unidad }}</td>
                                                        <td>{{ item.SubUnidad }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <CBtnSave :poBtnSave="oBtnSave"></CBtnSave>
                            </div>
                        </div>
                    </div>
                </form>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModalOrdenCompra" :poBtnSave="oBtnSaveOrdenCompra">
            <template slot="Form">
                <FormOrdenCompra :poBtnSave="oBtnSaveOrdenCompra"></FormOrdenCompra>
            </template>
        </CModal>
    </div>
</template>

<script>
import FormOrdenCompra from '../entrada/OrdenesCompraModal.vue';
const EmitEjecuta = 'seccionMovimiento';
const EmitEjecuta2 = 'seccionOrdenCompra';
export default {
    name: 'FormEntrada',
    // props: ['Id'],
    components:{
        FormOrdenCompra,
    },
    data() {
        return {
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Entradas',
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModalOrdenCompra:{
                ModalTitle: "Asignar Orden de Compra",
                ModalNameId: 'ModalFormOrdenCompra',
                EmitSeccion: EmitEjecuta2,
                ModalSize:'lg',
                ShowFooter:false
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'Entrada',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSaveOrdenCompra:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            objMovimiento:{
                IdMovimiento:0,
                Folio:'',
                NLote:'',
                TipoMovimiento:'',
                Materiales:[]
            },
            segurity: {},
            errorvalidacion: [],
            OrdenCompraSeleccionada:{},
            Materiales:[],
            Emit: EmitEjecuta,
        }
    },
    methods: {
        async Guardar(){
            this.oBtnSave.DisableBtn = true;
            this.errorvalidacion = [];
            let BndError=false;
            let Mensaje="";

            this.Materiales.every((element)=>{
                if (element.CantidadEntrante=="") {
                    Mensaje='La Cantidad del Material ' + element.Material + " No Puede Estar Vacía";
                    BndError=true;
                    return false;
                }
                return true;
            })

            if (BndError) {
                this.oBtnSave.DisableBtn = false;
                this.$toast.warning(Mensaje);
                return false;
            }
            this.objMovimiento.Folio=this.OrdenCompraSeleccionada.Folio;
            this.objMovimiento.Materiales=JSON.stringify(this.Materiales);
            this.$http.post("movimientos",this.objMovimiento
            ).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Regresar(){
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
        AbrirModalOrdenCompra(){
            this.bus.$emit('NewModal_'+this.ConfigModalOrdenCompra.EmitSeccion,0);
        },
        SeleccionarOrdenCompra(item){
            this.OrdenCompraSeleccionada=item;
            item.orden_compra_detalle.map((element)=>{
                element.CantidadEntrante="";
            });
            this.objMovimiento.IdOrdenCompra=this.OrdenCompraSeleccionada.IdOrdenCompra;
            this.Materiales=this.OrdenCompraSeleccionada.orden_compra_detalle;
            this.bus.$emit('CloseModal_'+this.ConfigModalOrdenCompra.EmitSeccion);
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
        this.bus.$off('SeleccionarOrdenCompra');
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        this.ConfigLoad.ShowLoader = false;

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
        this.bus.$on('SeleccionarOrdenCompra',(item)=>{
            this.SeleccionarOrdenCompra(item);
        });
    },
}
</script>

<style>

</style>